function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "red",
    stroke: "red",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.03735,0.22731,-17.8992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.465,76.29C90.465,73.464 88.085,71.17 85.154,71.17L14.391,71.17C11.46,71.17 9.081,73.464 9.081,76.29L9.081,86.529C9.081,89.355 11.46,91.649 14.391,91.649L85.154,91.649C88.085,91.649 90.465,89.355 90.465,86.529L90.465,76.29Z",
    style: {
      fill: "none",
      strokeWidth: "2.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9783,0,0,0.933573,-5.89302,-16.4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.525,77.526L18.967,77.526L37.856,40.1L75.636,40.1L94.525,77.526Z",
    style: {
      fill: "none",
      strokeWidth: "3.14px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.80843,-1.02357)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 62.981,
    width: 38.416,
    height: 10.251,
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.1993,-10.0573,-14.3635)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.805405,1.58884,15.8686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.156,
    y: 63.403,
    width: 31.424,
    height: 32.66,
    style: {
      fill: "white",
      strokeWidth: "3.05px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.142,73.231L79.893,73.231",
    style: {
      fill: "none",
      strokeWidth: "2.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.142,79.768L79.893,79.768",
    style: {
      fill: "none",
      strokeWidth: "2.72px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,6.36328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.142,79.768L79.893,79.768",
    style: {
      fill: "none",
      strokeWidth: "2.72px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967319,0,0,1.04478,17.1567,-20.9058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.098,31.229C54.098,29.597 52.667,28.272 50.904,28.272L32.929,28.272C31.167,28.272 29.736,29.597 29.736,31.229L29.736,37.143C29.736,38.775 31.167,40.1 32.929,40.1L50.904,40.1C52.667,40.1 54.098,38.775 54.098,37.143L54.098,31.229Z",
    style: {
      fill: "none",
      strokeWidth: "2.98px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.957966,3.56515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.31925,16.0761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.11684,3.56515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.02434,16.0761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,19.1916,3.56515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,13.3679,16.0761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,29.2665,3.56515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,24.7115,16.0761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,36.0551,16.0761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.597,30.133L34.094,30.133L34.97,28.212L36.721,28.212L37.597,30.133Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/checkout.b4b5648533b52f86a93ced63ede85728.svg";
export { ForwardRef as ReactComponent };